/**
 * Unescape special characters in the URI function unescape [%27]
 * @param  {string} str URI string to be unescaped
 * @return {string}     Unescaped URI string
 *
 * @deprecated Use `decodeURIComponent` directly\
 * Even though encodeURIComponent does not encode EVERYTHING, decodeURIComponent will decode everything
 */
export const unescapeURI = (str: string) => {
	return decodeURIComponent(str.replace('%27', "'"));
};

export default unescapeURI;
